import { BatchStatus } from "../../../types/mes";
import { formatClockTime } from "../../../utils/processParameterSerialize";

export const BATCH_STATUS_LABELS: Record<string, string> = {
  planned: "Planirano",
  ready: "Spremno",
  in_progress: "U tijeku",
  completed: "Završeno",
  on_hold: "Pauza",
  skipped: "Preskočeno",
  canceled: "Otkazano",
};

export const batchStatusLabel = (status?: string | null): string =>
  (status && BATCH_STATUS_LABELS[status]) || status || "-";

export const formatHrDate = (value?: string | null): string => {
  if (!value) return "-";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "-";
  return d.toLocaleDateString("hr-HR");
};

export const formatHrDateTime = (value?: string | null): string => {
  if (!value) return "-";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "-";
  return d.toLocaleString("hr-HR");
};

export const formatHrTime = (value?: string | null): string => formatClockTime(value);

export const formatNum = (value?: number | string | null, digits = 2): string => {
  if (value === null || value === undefined || value === "") return "-";
  const n = Number(value);
  if (Number.isNaN(n)) return "-";
  return n.toFixed(digits);
};

export type BatchStatusKey = BatchStatus;
